export default function CustomAttributeOnMap() {
  if (!HQ.Properties.maptilesAttribution) {
    return;
  }

  const customAttribution = `${HQ.Properties.maptilesAttribution}`;

  map.attributionControl.addAttribution(customAttribution);
}
